import api from '@/lib/api';
import type { PageResponse } from '@/types/admin.model';
import { toPageResponse } from '@/types/admin.model';

export type ClubStatus = 'ENABLED' | 'IN_PROGRESS' | 'DISABLED';

/**
 * A club as the backoffice sees it. The shape is fixed by the backend, which
 * pins its own projection (ControllerConstant.ADMIN_CLUB_FIELDS) and ignores a
 * `fields` query param — the enable queue lists every club on the platform, so
 * the projection is not the caller's to choose.
 */
export interface AdminClub {
  id: string;
  name: string;
  status: ClubStatus;
  cuit?: string | null;
  email?: string | null;
  cellphone?: string | null;
  owners?: { pk: string; email: string; name: string | null }[] | null;
}

export const adminClubsApi = {
  list: async (
    status: ClubStatus | '',
    page: number,
    size: number,
  ): Promise<PageResponse<AdminClub>> => {
    const response = await api.get('/clubs/admin', {
      params: {
        status: status || undefined,
        page,
        size,
      },
    });
    return toPageResponse<AdminClub>(response.data);
  },

  enable: async (clubId: string): Promise<void> => {
    await api.patch(`/clubs/admin/${clubId}/enable`);
  },
};
